module.exports = __webpack_public_path__ + "assets/img/btn-download-hover-3251b710.png";